/* eslint-disable */
import campaignConfig from './config';
import config from '@/config';
import CampaignAPIs from '../Campaign/campaignAPIs';
import campaignHelper from './campaignHelper';
import moment from 'moment'
import sumBy from 'lodash/sumBy';
import sum from 'lodash/sum';
import utils from '@/utils';
import { getReportPlatform, getReportProfileUrl } from '@/utils/reportPlatform'
// import config from '@/config';
export default {
  fixAnglesData(angles) {
    // Nyein - Fix for old angle data format for multiples
    angles = angles.map(angle => {
      const cpAngle = Object.assign({}, angle);
      //  restructure array for multiple options, formats
      if (cpAngle.required_action || cpAngle.required_action === '') {
        cpAngle.formats = []
        let format = this.getAngleFormat()
        format.required_action = cpAngle.required_action
        format.image_angle = cpAngle.image_angle
        format.content_angle = cpAngle.content_angle
        const sampleImages = angle.sample_images ? angle.sample_images : [];
        if (cpAngle.sample_image) {
          sampleImages.push({type: 'image', url: cpAngle.sample_image});
        }
        format.sample_images = sampleImages
        delete cpAngle.required_action;
        delete cpAngle.image_angle;
        delete cpAngle.content_angle;
        delete cpAngle.sample_images;
        delete cpAngle.sample_image;
        cpAngle.formats.push(format)
      }
      // fix sample images old data
      if (cpAngle.formats) {
        cpAngle.formats = cpAngle.formats.map(formatOne => {
          if (formatOne.sample_images) {
            formatOne.sample_images = formatOne.sample_images.map(sampleImage => {
              if (!sampleImage.type) {
                if (this.checkIfImage(sampleImage)) {
                  sampleImage = { type: 'image', url: sampleImage };
                } else {
                  sampleImage = { type: 'link', url: sampleImage };
                }
              }
              return sampleImage
            })
          }
          return formatOne;
        })
      }
      return cpAngle;
    });
    return angles
  },
  getAngleFormat() {
    return Object.assign({}, {
      required_action: '',
      image_angle: '',
      content_angle: '',
      sample_images: ''
    })
  },
  getDefaultAngle() {
    return Object.assign({}, {
      option_name: '',
      context: '',
      formats: [this.getAngleFormat()]
    })
  },
  checkIfImage(url) {
    const images = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG']
    let isImage = false
    images.map(img => {
      if (url.endsWith(img)) {
        isImage = true
      }
    })
    return isImage
  },
  getDefaultSegments() {
    return campaignConfig.userSegmentDisplay.map(u => u.value)
  },
  getYoutubePost: function(shortCode) {
    return `https://www.youtube.com/embed/${shortCode}`
  },
  getTikTokPost: function(shortCode) {
    return `https://www.tiktok.com/embed/${shortCode}`
  },
  getDeliverableNames: () => {
    return [
      {name: 'IGP', title: 'IG Post'},
      {name: 'IGC', title: 'IG Carousel'},
      {name: 'IGS', title: 'IG Story'},
      // {name: 'IGV', title: 'IG Video'},
      {name: 'IGR', title: 'IG Reel'},
      {name: 'TTP', title: 'TikTok Post'},
      {name: 'YTP', title: 'Youtube Post'},
      {name: 'XHS', title: 'XHS Post'},
      {name: 'Lemon8', title: 'Lemon8 Post'},
      {name: 'FBP', title: 'Facebook Post'},
      {name: 'LIP', title: 'LinkedIn Post'},
      {name: 'XTP', title: 'X (Twitter) Post'},
      {name: 'Others', title: 'Others'}
    ]
  },
  getDeliverableTitle: (postType) => {
    if (postType === 'IGP') {
      return 'IG Post'
    } else if (postType === 'IGC') {
      return 'IG Carousel'
    } else if (postType === 'IGR') {
      return 'IG Reel'
    } else if (postType === 'IGS') {
      return 'IG Story'
    } else if (postType === 'TTP') {
      return 'TikTok Post'
    } else if (postType === 'YTP') {
      return 'Youtube Post'
    } else if (postType === 'XHS') {
      return 'XHS Post'
    } else if (postType === 'FBP') {
      return 'Facebook Post'
    } else if (postType === 'LIP') {
      return 'LinkedIn Post'
    } else if (postType === 'XTP') {
      return 'X (Twitter) Post'
    } else if (postType === 'others') {
      return 'Others'
    }
    return ''
  },
  getDeliverableDetails: (details) => {
    let deliverables = []
    if (details) {
      if (details.no_of_tiktok_posts) {
        deliverables.push(`${details.no_of_tiktok_posts} X TTP`)
      }
      if (details.no_of_fb_posts) {
        deliverables.push(`${details.no_of_fb_posts} X FBP`)
      }
      if (details.no_of_xhs_posts) {
        deliverables.push(`${details.no_of_xhs_posts} X XHS`)
      }
      if (details.no_of_posts) {
        deliverables.push(`${details.no_of_posts} X IGP`)
      }
      if (details.no_of_carousels) {
        deliverables.push(`${details.no_of_carousels} X IGC`)
      }
      if (details.no_of_stories) {
        deliverables.push(`${details.no_of_stories} X IGS`)
      }
      if (details.no_of_video) {
        deliverables.push(`${details.no_of_video} X IGV`)
      }
      if (details.no_of_reels) {
        deliverables.push(`${details.no_of_reels} X IGR`)
      }
      if (details.no_of_li_posts) {
        deliverables.push(`${details.no_of_li_posts} X LIP`)
      }
      if (details.no_of_x_posts) {
        deliverables.push(`${details.no_of_x_posts} X X (Twitter) Post`)
      }
      if (details.youtube) {
        deliverables.push(`${details.youtube} X YTP`)
      }
      if (details.loading_whitelisting) {
        deliverables.push(`${details.loading_whitelisting} X Loading/Whitelisting`)
      }
      if (details.exclusivity) {
        deliverables.push(`${details.exclusivity} X Exclusivity`)
      }
      if (details.physical_attendance) {
        deliverables.push(`${details.physical_attendance}hrs X Physical Attendance`)
      }
      if (details.online_attendance) {
        deliverables.push(`${details.online_attendance}hrs X Online Attendance`)
      }
      if (details.custom) {
        details.custom.map(custom => {
          deliverables.push(`${custom.value} X ${custom.label}`)
        })
      }
      return deliverables.join(', ')
    }
    return 'N/A'
  },
  getTotalDeliverables: (details) => {
    let totalDeliverables = 0
    if (details.custom) {
      totalDeliverables = sumBy(details.custom, (c) => { return parseFloat(c.value) });
      delete details.custom
    }
    totalDeliverables += Object.keys(details).length > 0 ? sum(Object.values(details)) : 0
    return totalDeliverables
  },
  isAOKCampaign(type) {
    if (type === 'AOK' || type === campaignConfig.campaignType.AOK || type === campaignConfig.campaignType.Uncut) {
      return true
    }
    return false
  },
  isOtherCampaign(type) {
    if (type !== campaignConfig.campaignType.AOK && type !== campaignConfig.campaignType.Uncut) {
      return true
    }
    return false
  },
  async generateBlocks(item) {
    let blocks = []
    /**
     * Create Objectives Array
     */
    let ObjectiveArray = []
    if (item.campaign_brief_details.goal) {
      for (let goal of item.campaign_brief_details.goal) {
        ObjectiveArray.push(goal)
      }
    }
    /**
     * Generate Blocks for EditorJs with campaign brief data
     */
    blocks.push(
      {
        'type': 'title',
        'data': {
          'text': `<b>Client:</b> ${item.CampaignName}`
        }
      },
      {
        'type': 'title',
        'data': {
          'text': `<b>Objectives</b>`
        }
      },
      {
        'type': 'list',
        'data': {
          'style': 'unordered',
          'items': ObjectiveArray
        }
      },
      {
        'type': 'title',
        'data': {
          'text': `<b>Unique Advantage</b>`
        }
      },
      {
        'type': 'paragraph',
        'data': {
          'text': `${item.campaign_brief_details.uniqueAdvantage}`
        }
      },
      {
        'type': 'title',
        'data': {
          'text': `<b>Common Objections</b>`
        }
      },
      {
        'type': 'paragraph',
        'data': {
          'text': `${item.campaign_brief_details.commonObjective}`
        }
      }
    )
    /**
     * Adding Deliverables if there any
     */
    if (item.deliverables) {
      let deliverableArray = []
      if (item.deliverables.no_of_tiktok_posts > 0) {
        deliverableArray.push(`${item.deliverables.no_of_tiktok_posts} x TikTok Post`)
      } else if (item.deliverables.no_of_posts > 0) {
        deliverableArray.push(`${item.deliverables.no_of_posts} x IG Carousel Post`)
      } else if (item.deliverables.no_of_stories > 0) {
        deliverableArray.push(`${item.deliverables.no_of_stories} x IG Story with swipe up link`)
      } else if (item.deliverables.no_of_reels > 0) {
        deliverableArray.push(`${item.deliverables.no_of_reels} x IG Reel Post`)
      } else {
        deliverableArray.push(`${item.deliverables.no_of_video} x IG Video`)
      }

      blocks.push(
        {
          'type': 'title',
          'data': {
            'text': `<b>Deliverables</b>`
          }
        },
        {
          'type': 'list',
          'data': {
            'style': 'unordered',
            'items': deliverableArray
          }
        }
      )
    }
    /**
     * Adding Content angles after looking for deliverables
     */
    let contentAngles = this.fixAnglesData(item.campaign_brief_details.angles)
    for (let i = 0; i < contentAngles.length; i++) {
      blocks.push(
        {
          'type': 'title',
          'data': {
            'text': `<b>Concept ${i + 1}: ${contentAngles[i].option_name}</b>`
          }
        },
        {
          'type': 'paragraph',
          'data': {
            'text': '<u>Campaign Context:</u>'
          }
        },
        {
          'type': 'paragraph',
          'data': {
            'text': `${contentAngles[i].context}`
          }
        },
      )
      for (let j = 0; j < contentAngles[i].formats.length; j++) {
        let format = contentAngles[i].formats[j]
        blocks.push(
          {
            'type': 'paragraph',
            'data': {
              'text': '<u>Required action:</u>'
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': `${format.required_action}`
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': '<u>Image/Video Pointers:</u>'
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': `${format.image_angle}`
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': `<u>Content Pointers:</u>`
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': `${format.content_angle}`
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': `<u>Remarks:</u>`
            }
          },
          {
            'type': 'paragraph',
            'data': {
              'text': `${format.remark}`
            }
          }
        )
        blocks.push({
          'type': 'paragraph',
          'data': {
            'text': `<u>Mandatory Hashtags and Mentions:</u>`
          }
        })
        if (format.mandatory && format.mandatory.length > 0) {
          for (let mandatory of format.mandatory) {
            blocks.push({
              'type': 'paragraph',
              'data': {
                'text': `${mandatory}`
              }
            })
          }
        }
        if (format.sample_images.length > 0) {
          blocks.push({
            'type': 'title',
            'data': {
              'text': `<b>Image/Video Inspiration</b>`
            }
          })

          for (let s = 0; s < format.sample_images.length; s++) {
            let sampleImage = format.sample_images[s]
            if (sampleImage.type === 'image') {
              blocks.push({
                'type': 'image',
                'data': {
                  'url': `https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/${sampleImage.url}`,
                  'triggerRemoved': true
                }
              })
            } else {
              blocks.push({
                'type': 'paragraph',
                'data': {
                  'text': sampleImage.url
                }
              })
            }
          }
        }
      }
    }
    return blocks
  },
  calculateTotalPlayTime(posts, count = null) {
    let totalSeconds = 0
    posts.map(post => {
      let time = post.plays
      if (!time) {
        return false
      }
      let hours = time.match(/(.+?(?=h))/)
      let minutes = time.match(/(?::)(.*)(?=m)/)
      let seconds = time.match(/(?:m:)(.*)(?=s)/) // safari didn't support lookbehind, so replace extra strings
      if (hours && minutes && seconds) {
        totalSeconds += hours[1] ? parseFloat(hours[1]) * 3600 : 0
        totalSeconds += minutes[1] ? parseFloat(minutes[1].replace(':', '')) * 60 : 0
        totalSeconds += seconds[1] ? parseFloat(seconds[1].replace('m:', '')) : 0
      }
    })
    if (totalSeconds > 0) {
      if (count) {
        totalSeconds = parseInt(totalSeconds / parseInt(count))
      }
      let hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      return `${hours}h:${minutes}m:${seconds}s`
    }
    return '-'
  },
  calculateTotalReelWatchTime(posts) {
    let totalSeconds = 0
    posts.map(post => {
      let time = post.plays
      if (!time) {
        return false
      }
      let days = time.match(/(.+?(?=d))/)
      let hours = time.match(/(?::)(.*)(?=h)/)
      let minutes = time.match(/(?::)(.*)(?=m)/)
      let seconds = time.match(/(?:m:)(.*)(?=s)/) // safari didn't support lookbehind, so replace extra strings
      if (hours && minutes && seconds) {
        totalSeconds += days && days[1] ? parseFloat(days[1]) * 86400 : 0
        totalSeconds += hours[1] ? parseFloat(hours[1].replace(':', '')) * 3600 : 0
        totalSeconds += minutes[1] ? parseFloat(minutes[1].replace(':', '')) * 60 : 0
        totalSeconds += seconds[1] ? parseFloat(seconds[1].replace('m:', '')) : 0
      }
    })
    if (totalSeconds > 0) {
      // if (count) {
      //   totalSeconds = parseInt(totalSeconds / parseInt(count))
      // }
      let hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      return `${hours}h:${minutes}m:${seconds}s`
    }
    return '-'
  },
  formatTikTokPlayTime(totalPlayTime) {
    return `${totalPlayTime.hour}h:${totalPlayTime.minute}m:${totalPlayTime.second}s`
  },
  formatReelPlayTime(totalPlayTime) {
    return `${totalPlayTime.day}d:${totalPlayTime.hour}h:${totalPlayTime.minute}m:${totalPlayTime.second}s`
  },
  parseTikTokPlayTime(time) {
    let hours = time.match(/(.+?(?=h))/)
    let minutes = time.match(/(?::)(.*)(?=m)/)
    let seconds = time.match(/(?:m:)(.*)(?=s)/) // safari didn't support lookbehind, so need to replace extra strings
    let totalPlayTime = {
      hour: hours && hours[1] ? parseFloat(hours[1]) : 0,
      minute: minutes && minutes[1] ? parseFloat(minutes[1].replace(':', '')) : 0,
      second: seconds && seconds[1] ? parseFloat(seconds[1]) : 0
    }
    return totalPlayTime
  },
  parseSecondsToHms(totalSeconds) {
    totalSeconds = Number(totalSeconds)
    if (isNaN(totalSeconds) || totalSeconds < 0) {
      totalSeconds = 0
    }
    totalSeconds = Math.floor(totalSeconds)

    const hour = Math.floor(totalSeconds / 3600)
    const minute = Math.floor((totalSeconds % 3600) / 60)
    const second = totalSeconds % 60

    return {
      hour,
      minute,
      second
    }
  },
  parseReelPlayTime(time) {
    let days = time.match(/(.+?(?=d))/)
    let hours = time.match(/(?::)(.*)(?=h)/)
    let minutes = time.match(/(?::)(.*)(?=m)/)
    let seconds = time.match(/(?:m:)(.*)(?=s)/)
    let totalPlayTime = {
      day: days && days[1] ? parseFloat(days[1]) : 0,
      hour: hours && hours[1] ? parseFloat(hours[1].replace(':', '')) : 0,
      minute: minutes && minutes[1] ? parseFloat(minutes[1].replace(':', '')) : 0,
      second: seconds && seconds[1] ? parseFloat(seconds[1]) : 0
    }
    return totalPlayTime
  },
  showTikTokPlayTime(strTime) {
    const time = this.parseTikTokPlayTime(strTime)
    if (time.hour === 0) {
      strTime = strTime.replace('0h:', '')
    }
    if (time.minute === 0) {
      strTime = strTime.replace('0m:', '')
    }
    return strTime
  },
  parseReelPlayTimeHrs(time) {
    let hours = time.match(/(.+?(?=h))/)
    let minutes = time.match(/(?::)(.*)(?=m)/)
    let seconds = time.match(/(?:m:)(.*)(?=s)/)
    let totalPlayTime = {
      hour: hours && hours[1] ? parseFloat(hours[1].replace(':', '')) : 0,
      minute: minutes && minutes[1] ? parseFloat(minutes[1].replace(':', '')) : 0,
      second: seconds && seconds[1] ? parseFloat(seconds[1]) : 0
    }
    return totalPlayTime
  },
  showReelPlayTime(strTime) {
    const time = this.parseReelPlayTimeHrs(strTime)
    strTime = strTime.replace('0d:', '')
    if (time.hour === 0) {
      strTime = strTime.replace('0h:', '')
    }
    if (time.minute === 0) {
      strTime = strTime.replace('0m:', '')
    }
    return strTime
  },
  formatWatchTime(watch) {
    watch = watch.toString()
    if (watch.includes('s')) {
      return parseFloat(watch.replace('s', ''))
    }
    return watch
  },
  parseWatchTime(watch) {
    watch = watch.toString()
    if (!watch.includes('s')) {
      return `${watch}s`
    }
    return watch
  },
  async invokeReportOwnerCheck(context, payload) {
    return new Promise(async function (resolve) {
      const response = await CampaignAPIs.checkUserInCampaignReport(payload)
      if (!response.exists) {
        context.$swal({
          text: `Influencer's content is empty in Campaign Report`,
          type: 'warning',
          confirmButtonText: 'Continue'
        }).then(result => {
          if (result.value) {
            resolve(false)
          }
        });
      } else {
        resolve(true)
      }
    })
  },
  async checkPairingPayoutConfirm(context, payload) {
    return new Promise(async function (resolve) {
      const {handle, platform, pairingID, campaign, pairedInfluencers} = payload
      let validated = true
      let match = pairedInfluencers.find(p => {
        if (pairingID) {
          return p.pairingID === pairingID
        }
        if (!platform) {
          return p.instagramHandle === handle
        } else {
          return p.instagramHandle === handle && p.platform === platform
        }
      })
      if (!match || match.payoutStatus !== campaignConfig.payoutStatus.CONFIRMED) validated = false
      if (!validated) {
        context.$swal({
          html: `Please confirm payout for <b>${campaign.name}</b> - <b>@${handle}</b> `,
          type: 'warning',
          confirmButtonText: 'Continue',
          showCancelButton: true,
          cancelButtonText: 'Cancel'
        }).then(result => {
          if (result.value) {
            resolve(false)
          }
        });
      } else {
        resolve(true)
      }
    })
  },
  customMediaConfig(post, campaignType = null) {
    /**
    * supports for gdrive, cloudinary post views in campaign report
    * return if customMedia Object initialized (to prevent multiple calc on each call)
    */
    if (post.customMedia) return post.customMedia
    let response = {
      type: null,
      publicID: null,
      videoID: null,
      URL: '',
      width: 'auto',
      height: 'auto',
      trans: {}
    }
    if (post.isMultipleContents || post.type === 'story' || post.isXHS || post.isLemon) {
      // check for cloudinary media
      if (post.public_id) {
        if (post.internalView && post.thumbnail_url.includes('c_fill,h_320,w_320')) {
          response.type = 'v-img'
          response.URL = post.thumbnail_url
        } else {
          response.type = post.media_type === 'image' ? 'cld-image' : 'cld-video'
          response.URL = post.embed_url
          response.publicID = post.public_id
          if (response.type === 'cld-image') {
            response.trans = {
              aspectRatio: '5:9',
              loading: 'lazy'
            }
            if (post.internalView) {
              response.width = '100%'
            } else {
              response.width = 320
              response.height = 320
            }
          }
          if (response.type === 'cld-video') {
            response.className = post.internalView ? '' : 'report-video'
            response.videoID = Math.floor(Math.random() * 1000)
          }
        }
      } else {
        // check for g-drive
        response.URL = post.embed_url
        response.width = '100%'
        response.height = '100%'
        if (campaignType && this.isAOKCampaign(campaignType)) {
          response.type = 'driveCustomView'
        } else {
          response.className = 'media-iframe list'
          response.type = 'gdrive'
        }
        if (post.internalView) {
          response.download = false
        } else {
          response.download = true
        }
        if (post.media_type) {
          if (post.media_type === 'video') {
            if (!post.htmlReport) {
              response.height = '300px'
            } else {
              response.width = '300px'
            }
            response.type = 'video'
          }
          if (post.media_type === 'image') {
            response.width = '300px'
            if (!post.htmlReport) {
              response.height = '300px'
            }
            response.type = 'v-img'
          }
        }
      }
    }
    post.customMedia = response
    return post.customMedia
  },
  customPostMediaConfig(post, options = {}) {
    /**
    * supports for post submissions media view
    */
    let response = {
      type: null,
      publicID: null,
      videoID: null,
      URL: '',
      width: 'auto',
      height: 'auto',
      trans: {},
      detailView: false
    }
    // check for cloudinary media
    if (post.publicID) {
      response.type = post.type === 'image' ? 'cld-image' : 'cld-video'
      response.URL = post.file || post.url
      response.publicID = post.publicID
      if (response.type === 'cld-image') {
        response.trans = {
          aspectRatio: '5:9',
          loading: 'lazy',
          fetchFormat: 'png'
        }
        response.width = '100%'
        if (options.trans) {
          response.trans = Object.assign({}, response.trans, options.trans)
        }
      }
      if (response.type === 'cld-video') {
        response.className = 'post-video'
        response.videoID = Math.floor(Math.random() * 1000)
        if (options.videoDownload) {
          response.download = true
        }
        if (options.videoPreview) {
          response.preview = true
        }
      }
    } else {
      if (post.preview) {
        response.file = post.file
        response.preview = post.preview
        if (post.file) {
          response.fileName = post.file.name
        }
      }
      if (post.url && post.url.includes('s3-ap-southeast-1')) {
        response.URL = post.url
        if (response.URL) {
          let n = response.URL.lastIndexOf('/');
          let result = response.URL.substring(n + 1);
          response.fileName = result
        }
        if (post.isvideo) {
          response.isVideo = true
        } else {
          response.isImage = true
        }
      }
      if (options.videoDownload) {
        response.download = true
      }
      if (options.videoPreview) {
        response.preview = true
      }
    }
    if (options.overlay) response.overlay = true
    if (options.overlayType) response.overlayType = options.overlayType
    if (options.postView) response.postView = true
    if (options.creatorView) response.creatorView = true
    return response
  },
  getReportDeliverables(posts, fmt = 'string') {
    let deliverables = {IGP: 0, IGC: 0, IGS: 0, IGV: 0, IGR: 0, TTP: 0}
    for (let post of posts) {
      if (deliverables[post.type] || deliverables[post.type] === 0) {
        deliverables[post.type] += 1
      }
    }
    if (fmt === 'object') return deliverables
    let results = []
    for (var key of Object.keys(deliverables)) {
      if (deliverables[key] > 0) {
        results.push(`${deliverables[key]} X ${key}`)
      }
    }
    return results.join(', ')
  },
  getPostOutreachTotal(posts) {
    let outReach = 0
    for (let post of posts) {
      outReach += post.currentInsight && post.currentInsight.outreach ? post.currentInsight.outreach : 0
    }
    return outReach
  },
  getCampaignDurationMonths(item) {
    if (!item.startDate || !item.endDate) return '';
    const formattedStartDate = moment(item.startDate).format('YYYY-MM');
    const formattedEndDate = moment(item.endDate).format('YYYY-MM');
    return moment(formattedEndDate).diff(formattedStartDate, 'months', true) + 1
  },
  getMarkupCOGS(ioNumber, client) {
    // use double checks to make sure with old data
    if (!ioNumber || !client) return false
    let matchDeal = null
    if (client.account) {
      if (client.account.deals) {
        matchDeal = client.account ? client.account.deals.find(deal => `${this.cutIO(deal.IO)}` === this.cutIO(ioNumber)) : false
      }
    }
    if (matchDeal && matchDeal.markupCOGS) return matchDeal.cogsAmount
    return false
  },
  cutIO(IO) {
    var re = new RegExp('IO-', 'g')
    return IO.replace(re, '')
  },
  getMandatoryHashtagMentions(campaign) {
    if (!campaign.angles) return ''
    let contentAngles = this.fixAnglesData(campaign.angles)
    let hasTagSet = new Set()
    for (let i = 0; i < contentAngles.length; i++) {
      for (let j = 0; j < contentAngles[i].formats.length; j++) {
        let format = contentAngles[i].formats[j]
        if (format.mandatory && format.mandatory.length > 0) {
          for (let mandatory of format.mandatory) {
            hasTagSet.add(mandatory)
          }
        }
      }
    }
    return Array.from(hasTagSet).join(' ')
  },
  formatCountry(countries, givenCountries) {
    let selectedCountries = []
    if (typeof givenCountries === 'string') {
      givenCountries = [givenCountries]
    }
    if (!Array.isArray(countries) && !Array.isArray(givenCountries)) return selectedCountries
    if (givenCountries) {
      countries.map(item => {
        givenCountries.map(country => {
          if (item.code === country) {
            selectedCountries.push(item)
          }
        })
      })
    }
    return selectedCountries
  },
  getProductName(itemName) {
    if (itemName === 'aok') {
      return 'AOK/Uncut'
    }
    return itemName
  },
  getStageName(status) {
    if (status === config.campaignStatus.DRAFT || status === config.campaignStatus.PENDING_CLIENT_APPROVAL) {
      return campaignConfig.campaignStage.ACTIVATING
    } else if (status === config.campaignStatus.PAIRING_BRIEF || status === config.campaignStatus.PAIRING_INFLUENCER || status === config.campaignStatus.RATE_CARD) {
      return campaignConfig.campaignStage.PAIRING
    } else if (status === config.campaignStatus.ONGOING) {
      return campaignConfig.campaignStage.COCREATING
    } else {
      return campaignConfig.campaignStage.COMPLETE
    }
  },
  // --- GENERIC HELPER FOR COLUMN INITIALIZATION (GETS ORDER FROM SAVED OBJECT KEYS) ---
  getOrderedColumns(columnDefs, currentStatus, defaultStatus) {
    let currentOrder = [];
    let currentKeys = new Set();
    
    // 1. Get ordered keys from currentStatus (Relies on JS engine insertion order)
    if (currentStatus && Object.keys(currentStatus).length > 0) {
      Object.keys(currentStatus).forEach(key => {
        const colDef = columnDefs.find(c => c.name === key);
        if (colDef) {
          currentOrder.push({
            title: colDef.label,
            key: key,
            value: currentStatus[key]
          });
          currentKeys.add(key);
        }
      });
    }

    // 2. Add remaining default columns (that haven't been saved yet) to the end
    columnDefs.forEach(colDef => {
      if (!currentKeys.has(colDef.name)) {
        currentOrder.push({
          title: colDef.label,
          key: colDef.name,
          // Use default status for new columns, fallback to false
          value: defaultStatus.hasOwnProperty(colDef.name) ? defaultStatus[colDef.name] : false
        });
        currentKeys.add(colDef.name);
      }
    });
    return currentOrder;
  },
  calculatePostData(post, index) {
    const platform = getReportPlatform(post)
    const isLinkedIn = platform === 'linkedin'
    const isTwitter = platform === 'twitter'
    let postData = {}
    postData.campaign = post.campaign || {}
    postData.id = post.id
    postData.key = index
    postData.lineUpIndex = post.lineUpIndex
    postData.profileUrl = getReportProfileUrl(post, platform || (post.isTikTok ? 'tiktok' : 'instagram'))
    if (post.isCalculated) {
      return post
    }
    if (!isLinkedIn && !isTwitter && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isFacebook && !post.isOthers) {
      if (post.post_details) {
        if (post.post_details.owner) {
          postData.name = post.post_details.owner.username
          postData.engagement_rate_sd = post.post_details.owner.engagement_rate_sd || null
        }
        postData.url = post.post_details.link
      }
      postData.title = 'IG Post'
      postData.impressions = 0 // currently no used
      if (post.currentInsight) {
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
      }
      postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
      postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
      postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
      postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
      if (post.postType === 'IGR') {
        postData.type = 'reel'
        postData.title = 'IG Reel'
      } else {
        postData.type = 'post/carousel'
        postData.title = 'IG Post'
      }
      postData.postType = postData.postType || postData.type
      // for manual input data for posts
      if (post.inputtedInsights) {
        postData.saved = post.inputtedInsights.saved
        postData.shares = post.inputtedInsights.shares
        postData.views = post.inputtedInsights.views || 0 // newly added views, so there could be null
        postData.reach = post.inputtedInsights.reach || 0
        postData.impressions = post.inputtedInsights.impressions || 0
      } else {
        postData.saved = post.graphInsight ? post.graphInsight.saved : 0 // bookmarks
        postData.shares = 0 // no data default to 0
        postData.views = 0 // no data default to 0
      }
      postData.new_engagement_rate = Number((((postData.likes + postData.comments + postData.saved + postData.shares) / postData.outreach) * 100).toFixed(2))
      postData.new_engagement_rate_view = Number((((postData.views) / postData.outreach) * 100).toFixed(2))
      postData.engagement_rate_reach = Number((((postData.likes + postData.comments + postData.saved + postData.shares) / postData.reach) * 100).toFixed(2))
      postData.interactions = ((postData.likes || 0) + (postData.comments || 0) + (postData.saved || 0) + (postData.shares || 0))
    } else if (post.isStory && post.insights) {
      postData.name = post.owner.username
      postData.outreach = post.owner.followers || post.owner.followers_sd
      postData.title = 'IG Story'
      postData.url = post.media_url || `https://app.getkobe.com/static/img/kobe_white.png`
      postData.engagement = Number(post.insights.engagement) || 0
      postData.impressions = Number(post.insights.impressions) || 0
      postData.reach = Number(post.insights.reach) || 0
      postData.replies = Number(post.insights.replies) || 0
      postData.exits = Number(post.insights.exits) || 0
      postData.taps_back = Number(post.insights.taps_back) || 0
      postData.taps_forward = Number(post.insights.taps_forward) || 0
      postData.shares = Number(post.insights.shares) || 0
      postData.sticker_taps = Number(post.insights.sticker_taps) || 0
      postData.link_clicks = Number(post.insights.link_clicks) || 0
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
      postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
      postData.type = 'story'
      postData.postType = postData.postType || postData.type
      postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1
      postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps
      postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
      postData.public_id = post.public_id || null
    } else if (post.isTikTok) {
      postData.name = post.owner.username
      postData.title = 'TikTok Post'
      if (post.post_details) {
        postData.url = post.post_details.link
        postData.shortCode = post.post_details.shortcode
      }
      postData.impressions = 0 // currently no used
      postData.engagement = post.currentInsight.engagement || 0
      postData.reach = 0 // currently no used
      postData.likes = post.currentInsight.like_count || 0
      postData.comments = post.currentInsight.comment_count || 0
      postData.shares = post.currentInsight.shares || 0
      postData.views = post.currentInsight.views || 0
      postData.outreach = post.currentInsight.outreach || 0
      postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
      postData.engagement_rate_sd = post.owner.engagement_rate_sd || null
      postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
      postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
      postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
      postData.type = 'tiktok'
      postData.postType = postData.postType || postData.type
      // for manual input data for posts
      if (post.inputtedInsights) {
        postData.saved = post.inputtedInsights.saved
        if (postData.shares === 0) {
          postData.shares = post.inputtedInsights.shares
        }
        if (postData.views === 0) {
          postData.views = post.inputtedInsights.views || 0 // newly added views, so there could be null
        }
        postData.reach = post.inputtedInsights.reach || 0
        postData.impressions = post.inputtedInsights.impressions || 0
        postData.plays = post.inputtedInsights.plays || 0
        postData.watches = post.inputtedInsights.watches ? campaignHelper.parseWatchTime(post.inputtedInsights.watches) : 0
        postData.watchedFullVideo = post.inputtedInsights.watchedFullVideo || 0
      } else {
        postData.saved = post.graphInsight ? post.graphInsight.saved : 0 // bookmarks
        postData.shares = 0 // no data default to 0
        postData.views = 0 // no data default to 0
        postData.reach = 0
        postData.impressions = 0
        postData.plays = 0
        postData.watches = 0
      }
      postData.new_engagement_rate = ((((postData.likes || 0) + (postData.comments || 0) + (postData.shares || 0)) / (postData.outreach || 0)) * 100).toFixed(2)
      postData.interactions = Number((postData.likes || 0) + (postData.comments || 0) + (postData.saved || 0) + (postData.shares || 0))
      postData.interaction_rate_plays = 0
      postData.eng_rate_total_viewers = 0
      if (post.views) {
        postData.interaction_rate_plays = ((((postData.likes || 0) + (postData.comments || 0) + (postData.shares || 0)) / Number(postData.views)) * 100).toFixed(2)
        postData.eng_rate_total_viewers = ((((postData.likes || 0) + (postData.comments || 0) + (postData.saved || 0) + (postData.shares || 0)) / Number(postData.reach)) * 100).toFixed(2)
      }
      postData.new_engagement_rate_view = Number((((postData.views) / postData.outreach) * 100).toFixed(2))
    } else if (post.isYoutube) {
      postData.name = post.owner.username
      postData.title = 'Youtube Post'
      if (post.post_details) {
        postData.url = post.post_details.link
        postData.shortCode = post.post_details.shortcode
      }
      postData.type = 'youtube'
      postData.postType = postData.postType || postData.type
      postData.impressions = 0 // currently no used
      postData.engagement = post.currentInsight.engagement || 0
      postData.reach = 0 // currently no used
      postData.likes = post.currentInsight.like_count || 0
      postData.comments = post.currentInsight.comment_count || 0
      postData.views = post.currentInsight.views || 0
      postData.outreach = post.currentInsight.outreach || 0
      postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
      postData.engagement_rate_sd = post.owner.engagement_rate_sd || null
      postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
      postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
      postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
      postData.new_engagement_rate = ((((postData.likes || 0) + (postData.comments || 0)) / (postData.outreach || 0)) * 100).toFixed(2)
      // for manual input data for posts, currently no used
      // if (post.inputtedInsights) {
      //   postData.outreach = post.inputtedInsights.outreach || 0
      //   postData.engagement_rate = post.inputtedInsights.engagement_rate || 0
      //   postData.like_count = post.inputtedInsights.like_count || 0
      //   postData.comment_count = post.inputtedInsights.comment_count || 0
      //   postData.reach = post.inputtedInsights.reach || 0
      //   postData.impressions = post.inputtedInsights.impressions || 0
      // } else {
      //   postData.outreach = 0 // no data default to 0
      //   postData.engagement_rate = 0 // no data default to 0
      //   postData.like_count = 0 // no data default to 0
      //   postData.comment_count = 0 // no data default to 0
      //   postData.reach = 0
      //   postData.impressions = 0
      // }
    } else if (post.isFacebook && post.insights) {
      postData.name = post.owner.username
      postData.outreach = post.owner.followers || post.owner.followers_sd
      postData.title = 'Facebook'
      postData.url = post.media_url || `https://app.getkobe.com/static/img/kobe_white.png`
      postData.outreach = Number(post.insights.outreach) || 0
      postData.like_count = Number(post.insights.like_count) || 0
      postData.comment_count = Number(post.insights.comment_count) || 0
      postData.views = Number(post.insights.views) || 0
      postData.shares = Number(post.insights.shares) || 0
      postData.bookmarks = Number(post.insights.bookmarks) || 0
      postData.interactions = ((postData.like_count || 0) + (postData.comment_count || 0) + (postData.bookmarks || 0) + (postData.shares || 0))
      postData.type = 'facebook'
    } else if (post.isXHS && post.insights) {
      postData.name = post.owner.username
      postData.outreach = post.owner.followers || post.owner.followers_sd
      postData.title = 'XHS'
      postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
      postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
      postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
      postData.xhsLink = post.xhsLink || ''
      postData.outreach = Number(post.insights.outreach) || 0
      postData.like_count = Number(post.insights.like_count) || 0
      postData.comment_count = Number(post.insights.comment_count) || 0
      postData.views = Number(post.insights.views) || 0
      postData.shares = Number(post.insights.shares) || 0
      postData.bookmarks = Number(post.insights.bookmarks) || 0
      postData.type = 'xhs'
      postData.isXHS = true
      postData.interactions = ((postData.like_count || 0) + (postData.comment_count || 0) + (postData.bookmarks || 0) + (postData.shares || 0))
    } else if ((isLinkedIn || isTwitter || post.isOthers) && post.insights) {
      const latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null
      const insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights
      const insights = Object.assign({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {})
      postData.name = post.owner.username
      postData.outreach = Number(insights.outreach) || Number(post.owner.followers || post.owner.followers_sd) || 0
      postData.title = isLinkedIn ? 'LinkedIn Post' : (isTwitter ? 'X (Twitter) Post' : 'Other Post')
      postData.url = post.post_details ? post.post_details.link : ''
      postData.like_count = Number(insights.like_count) || 0
      postData.comment_count = Number(insights.comment_count) || 0
      postData.impressions = Number(insights.impressions != null ? insights.impressions : (isTwitter ? insights.views : 0)) || 0
      postData.views = isTwitter ? postData.impressions : (Number(insights.views) || 0)
      postData.reach = Number(insights.reach != null ? insights.reach : (isLinkedIn ? insights.outreach : 0)) || 0
      postData.shares = Number(insights.shares) || 0
      postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0
      postData.saved = postData.bookmarks
      postData.interactions = postData.like_count + postData.comment_count + postData.bookmarks + postData.shares
      postData.type = isLinkedIn ? 'linkedin' : (isTwitter ? 'twitter' : 'others')
      postData.postType = postData.postType || (isLinkedIn ? 'LIP' : (isTwitter ? 'XTP' : 'Others'))
    } else if (post.isMultipleContents) {
      postData.name = post.owner.username
      postData.outreach = post.owner.followers || post.owner.followers_sd
      postData.title = 'IG Story'
      postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
      postData.type = 'gdrive'
      postData.postType = postData.postType || 'story'
      postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
      postData.public_id = post.public_id || null
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
      postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
      if (post.insights) {
        postData.engagement = Number(post.insights.engagement) || 0
        postData.impressions = Number(post.insights.impressions) || 0
        postData.reach = Number(post.insights.reach) || 0
        postData.replies = Number(post.insights.replies) || 0
        postData.exits = Number(post.insights.exits) || 0
        postData.taps_back = Number(post.insights.taps_back) || 0
        postData.taps_forward = Number(post.insights.taps_forward) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.sticker_taps = Number(post.insights.sticker_taps) || 0
        postData.link_clicks = Number(post.insights.link_clicks) || 0
        postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1
        postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps
      }
    }
    postData.live_date = post.live_date ? utils.func.formatDate(post.live_date) : '-'
    postData.isCalculated = true
    return postData
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/campaignHelper.js